import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import {
    FiAiAssistanceResponseStatus,
    IAIAssistancePrompt,
    IAIRequestHistoryModel,
} from '@fi-shared/fi-ai-assistance/fi-ai-assistance';
import { isDefined } from '@fi-shared/utils';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'fi-checklist-ai-request-editor',
    templateUrl: './checklist-ai-request-editor.component.html',
    styleUrl: './checklist-ai-request-editor.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checklist-ai-request-editor' },
    standalone: false,
})
export class FiChecklistAiRequestEditor implements OnInit, OnDestroy {
    @Input() loadingAIResponse$ = new BehaviorSubject<boolean>(false);
    @Input() aiPromptSamples$ = new BehaviorSubject<IAIAssistancePrompt[]>([]);
    @Input() recentAIRequests$ = new BehaviorSubject<IAIRequestHistoryModel[]>([]);
    @Input() aiResponseStatus$ = new Observable<FiAiAssistanceResponseStatus>();

    @Output() sendRequest = new EventEmitter<string>();
    @Output() cancel = new EventEmitter<void>();
    @Output() resetAiResponseStatus = new EventEmitter<void>();

    @Input() aiRequestMessage: string;
    @Output() aiRequestMessageChange = new EventEmitter<string>();

    private aiResponseStatus: FiAiAssistanceResponseStatus;

    constructor(private cdr: ChangeDetectorRef) {}

    public ngOnInit(): void {
        this.aiResponseStatus$.pipe(takeUntil(this.ngOnDestroy$)).subscribe((status: FiAiAssistanceResponseStatus) => {
            this.aiResponseStatus = status;
            this.cdr.markForCheck();
        });
    }

    protected onAiRequestMessageChange(): void {
        this.aiRequestMessageChange.emit(this.aiRequestMessage);
    }

    protected isAiRequestFailed(): boolean {
        return this.aiResponseStatus === FiAiAssistanceResponseStatus.Failed;
    }

    protected onMessageEditorFocus(): void {
        this.resetAiResponseStatus.emit();
    }

    protected onSendRequest(): void {
        this.sendRequest.emit(this.aiRequestMessage);
    }

    protected onRecentRequestClick(recentRequest: IAIRequestHistoryModel): void {
        this.aiRequestMessage = recentRequest.Message;
        this.onAiRequestMessageChange();
    }

    protected onSampleClick(promptSample: IAIAssistancePrompt): void {
        this.aiRequestMessage = promptSample.Prompt;
        this.onAiRequestMessageChange();
    }

    protected onCancel() {
        this.cancel.emit();
    }

    protected isPrimaryButtonDisabled(): boolean {
        return !isDefined(this.aiRequestMessage) || this.aiRequestMessage.trim() === '';
    }

    private ngOnDestroy$ = new Subject<void>();
    public ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
